import Vue from "vue";

const Utils = {
  setLocaleToBCP47: (lang) => {
    let locale;
    switch (lang) {
      case "fr":
        locale = "fr-FR";
        break;
      default:
        locale = "en-US";
    }
    return locale;
  },
  numberformat: (
    value,
    lang,
    minimumFractionDigits = 0,
    style = "currency",
    currency = "XAF"
  ) => {
    var formatter = new Intl.NumberFormat(lang, {
      style: style,
      currency: currency,
      minimumFractionDigits: minimumFractionDigits,
    });

    return formatter.format(value);
  },
  normalizeDaterange: (dates, format = "YYYY-MM-DD") => {
    const start = Vue.moment(dates[0], format);
    const end = Vue.moment(dates[1], format);

    if (start.isAfter(end)) {
      return [end.format(format), start.format(format)];
    }

    return [start.format(format), end.format(format)];
  },
};
Utils.install = function(VueJs) {
  if (!VueJs.$utils) {
    VueJs.$utils = Utils;
    Object.defineProperties(VueJs.prototype, {
      $utils: {
        get() {
          return Utils;
        },
      },
    });
  }
};

Vue.use(Utils);
